import React, { Component } from 'react'
import * as PropTypes from 'prop-types'
import Button from 'components/Button'
import BarPage from 'components/Layout/BarPage'
import CtaTopRight from 'components/CtaTopRight'
import PasswordResetForm from './PasswordResetForm'

import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'

export default class PasswordReset extends Component {
  static propTypes = {
    passwordReset: PropTypes.func.isRequired,
  }
  submit = formData => {
    const { passwordReset } = this.props
    return passwordReset({
      email: formData.email,
    })
  }
  render() {
    return (
      <BarPage>
        <CtaTopRight text="Have an account?">
          <Button to="/login" plain size="sm" className={sLay['hide-gt-xs']}>
            Log in
          </Button>
          <Button to="/login" ghost color="tertiary" size="sm" className={sLay['hide-xs']}>
            Log in
          </Button>
        </CtaTopRight>
        <div className={cn(sLay.flex, sLay['layout-column'], sLay['layout-align-center-center'])}>
          <PasswordResetForm onSubmit={this.submit} />
        </div>
      </BarPage>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/PasswordReset/PasswordReset.jsx